import React, { useState } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    Container,
    CircularProgress
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
    borderRadius: '12px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
    },
}));

const StyledButton = styled(Button)(({ theme }) => ({
    padding: theme.spacing(1.5),
    borderRadius: '8px',
    fontWeight: 'bold',
    textTransform: 'none',
    fontSize: '16px',
}));

const DepartamentoForm = () => {
    const [nombre, setNombre] = useState('');
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const API_URL = 'https://dymesenergy.gst-panel.com/agregar/guardar_departamentos.php';

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!nombre.trim()) {
            enqueueSnackbar('El nombre del departamento es requerido', {
                variant: 'error',
                autoHideDuration: 3000
            });
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(API_URL, {
                Nombre: nombre
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            if (response.data.success) {
                enqueueSnackbar(`Departamento "${nombre}" agregado con éxito`, {
                    variant: 'success',
                    autoHideDuration: 5000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    }
                });
                setNombre('');
            } else {
                throw new Error(response.data.message || 'Error al crear departamento');
            }
        } catch (error) {
            console.error('Error:', error);
            let errorMessage = 'Ocurrió un problema al agregar el departamento';

            if (error.response) {
                errorMessage = error.response.data.message || errorMessage;
            } else if (error.request) {
                errorMessage = 'No se pudo conectar con el servidor';
            }

            enqueueSnackbar(errorMessage, {
                variant: 'error',
                autoHideDuration: 5000,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="md">
            <StyledPaper elevation={3}>
                <Typography variant="h4" component="h1" gutterBottom sx={{
                    fontWeight: 'bold',
                    color: 'primary.main',
                    marginBottom: 3
                }}>
                    Agregar Nuevo Departamento
                </Typography>

                <Box component="form" onSubmit={handleSubmit}>
                    <StyledTextField
                        fullWidth
                        label="Nombre del Departamento"
                        variant="outlined"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        disabled={loading}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <StyledButton
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                        >
                            {loading ? 'Guardando...' : 'Guardar Departamento'}
                        </StyledButton>
                    </Box>
                </Box>
            </StyledPaper>
        </Container>
    );
};

export default DepartamentoForm;